import React from "react";
import { NavMenuItemNode } from "./nav-menu-utils";

export interface NavMenuContextValue<P extends Record<string, unknown>> {
  navMenuProps: P;
  getMenuItemNode: (id: string) => NavMenuItemNode | null;
  activeNavMenuItem: string | undefined;
  activeNavMenuPath: string[];
  updateActiveNavMenuPath: (id: string) => void;
  getActiveMenuItemNode: () => NavMenuItemNode | null;
  expandedNavMenuItems: string[];
  toggleNavMenuItemExpanded: (id: string) => void;
  isMobile: boolean;
  isMobileMenuOpen: boolean;
  isMobileMenuVisible: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
}

/**
 * The `NavMenuContext` is used to make Nav Menu relates state and manipulator function available to potentially deeply
 * nested Nav Menu Item element under a Nav Menu without the need to pass down props across potentially multiple levels
 * of the menu item hierarchy.
 */
export const NavMenuContext = React.createContext<NavMenuContextValue<Record<string, unknown>>>(undefined);

NavMenuContext.displayName = "NavMenuContext";
